import { syncCompanyNameValidator } from 'signup-ui-lego-core/validaton/companyNameValidator';
import { getFlowSpecificErrorMessage } from '../../../utils/getFlowSpecificErrorMessage';

const getErrorMessage = (_value, error, dataKey) => {
  return getFlowSpecificErrorMessage(dataKey, error);
};

export const companyNameValidator = {
  sync: syncCompanyNameValidator,
  getErrorMessage
};